import { render, staticRenderFns } from "./case_reviews.vue?vue&type=template&id=5c188e1a&scoped=true"
import script from "./case_reviews.vue?vue&type=script&lang=js"
export * from "./case_reviews.vue?vue&type=script&lang=js"
import style0 from "./case_reviews.vue?vue&type=style&index=0&id=5c188e1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c188e1a",
  null
  
)

export default component.exports